import { CreateUserResponse, ListUsersByPageResponse, User, UserRole } from '../gen/proto/api/gateway/v1/user_pb';
import { userStateClient } from './api-grpc';

export const userApi = {
  async listUsersByPage(pageIndex: number, pageSize: number): Promise<ListUsersByPageResponse> {
    return await userStateClient.listUsersByPage({
      pagination: { pageIndex, pageSize },
    });
  },

  async getUserByUuid(uuid: string): Promise<User> {
    const response = await userStateClient.getUserByUuid({
      uuid: uuid,
    });
    if (!response.user) {
      throw new Error('User with uuid' + uuid + ' not found');
    }
    return response.user;
  },

  async blockUser(uuid: string): Promise<User> {
    const response = await userStateClient.blockUser({ userUuid: uuid });
    if (!response.user) {
      throw new Error('User with uuid' + uuid + ' not found');
    }
    return response.user;
  },

  async unblockUser(uuid: string): Promise<User> {
    const response = await userStateClient.unblockUser({ userUuid: uuid });
    if (!response.user) {
      throw new Error('User with uuid' + uuid + ' not found');
    }
    return response.user;
  },

  async updateUser(userUuid: string, name: string, email: string, role: UserRole, tenantUuid: string): Promise<void> {
    await userStateClient.updateUser({
      uuid: userUuid,
      name: name,
      email: email,
      role: role,
      tenantUuid: tenantUuid,
    });
  },

  async updateUserRole(userUuid: string, role: UserRole): Promise<void> {
    await userStateClient.updateUserRole({
      userUuid: userUuid,
      role: role,
    });
  },

  async resetUserPassword(newPassword: string, userUuid: string): Promise<void> {
    await userStateClient.resetUserPassword({ newPassword: newPassword, userUuid: userUuid });
  },

  async createUser(email: string, name: string, role: UserRole, tenantUuid: string): Promise<CreateUserResponse> {
    const response = await userStateClient.createUser({ email: email, name: name, role: role, tenantUuid: tenantUuid });
    if (!response.user) {
      throw new Error("Couldn't create user");
    }
    return response;
  },

  async getAdminByTenant(tenantUuid: string): Promise<User[]> {
    const response = await userStateClient.getCompanyAdminFromTenant({ tenantUuid: tenantUuid });
    if (!response) {
      throw new Error("Couldn't get company admin");
    }
    return response.companyAdmins;
  },
};
